import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import { Box, Button, Typography } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ImageLoader from "../Loader/ImageLoader";
import Typed from "typed.js";

import "./home.css";

export default function Home() {
  const el = useRef(null);
  const [imageLoading, setImageLoading] = useState(true);
  const typedRef = useRef(null);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    const typedRef = new Typed(el.current, {
      strings: [
        "Scalable Applications",
        "Backend Systems & APIs",
        "Cloud & DevOps",
      ],

      typeSpeed: 100,
      backSpeed: 50,
      backDelay: 1000,
      loop: true,
    });
    return () => typedRef.destroy();
  });

  useLayoutEffect(() => {
    const observer = new IntersectionObserver(callBack);
    if (typedRef.current) observer.observe(typedRef.current);
    function callBack(item) {
      item.forEach((entry) => {
        if (entry.isIntersecting) typedRef.current?.start();
        else typedRef.current?.stop();
      });
    }
    return () => typedRef.current && observer.unobserve(typedRef.current);
  }, []);

  const getExperience = () => {
    const start = new Date(2022, 5); // June 2022
    const now = new Date();

    let years = now.getFullYear() - start.getFullYear();
    const monthDiff = now.getMonth() - start.getMonth();

    if (monthDiff < 0) years--;

    return `${years}+`;
  };

  const experience = getExperience();

  return (
    <section id="home">
      <Box className="home-container">
        <Box className="left-side">
          <Typography variant="h5" className="solutation title">
            Hello & Welcome, It's Me
          </Typography>
          <Typography variant="h3" className="title !font-bold" id={!isMobile ? "fromRight" : ""}>
            Ghulam Ullah
          </Typography>
          <Box className="logo flex">
            <Typography variant="h4" className="title">
              I build
            </Typography>
            <Typography variant="h4" ref={el} className="animating-text" />
          </Box>
          <Typography variant="h6" className="desc title">
            Full Stack Engineer with {experience} years of experience building scalable web applications using Node.js, React, Next.js, TypeScript, and cloud technologies. Passionate about clean architecture and exceptional user experiences.
          </Typography>
          <Box className="icons-main">
            <Box component={"a"} href="https://www.facebook.com/ghulamullah123" className="no-underline" target="_blank">
              <FacebookIcon className="icon-link" id="list" style={{ "--i": 1 }} />
            </Box>
            <Box component={"a"} href="https://github.com/GhulamUllah" className="no-underline" target="_blank">
              <GitHubIcon className="icon-link" id="list" style={{ "--i": 2 }} />
            </Box>
            <Box component={"a"} href="https://www.linkedin.com/in/ghulam-ullah-695188175/" className="no-underline" target="_blank">
              <LinkedInIcon className="icon-link" id="list" style={{ "--i": 3 }} />
            </Box>
            <Box component={"a"} href="https://api.whatsapp.com/send/?phone=923096126978&text&type=phone_number&app_absent=0" className="no-underline" target="_blank">
              <WhatsAppIcon className="icon-link" id="list" style={{ "--i": 4 }} />
            </Box>
          </Box>
          <Box className="icons-main">
            <Box className="desc flex no-underline" component={"a"} href="/GHULAM_ULLAH_Resume.pdf" target="_blank">
              <Button variant="contained" className="cv">
                Download CV
              </Button>
            </Box>
          </Box>
        </Box>
        <Box className="right-side" id={!isMobile ? "fromRight" : ""}>
          {imageLoading && <ImageLoader />}
          <img onLoad={() => setImageLoading(false)} src="/assets/upwork-profile.png" alt="Not Found" />
        </Box>
      </Box>
    </section>
  );
}
